import React from "react";
import { useModalSubscriptionSetupHook } from "./modal-subscription-setup-hooks";

type ContextModalSubscriptionSetup = ReturnType<
  typeof useModalSubscriptionSetupHook
>;
export const ModalSubscriptionSetupContext =
  React.createContext<ContextModalSubscriptionSetup | null>(null);

export function useContextModalSubscriptionSetup() {
  const context = React.useContext(ModalSubscriptionSetupContext);

  if (!context) {
    throw new Error(
      "useContextModalSubscriptionSetup must be used within a ContextModalSubscriptionSetupProvider",
    );
  }

  return context;
}
